import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        background: '#FFFFFF',
      },
      dark: {
        background: '#121212',
      },
    },
    options: {
      customProperties: true,
    },
  },
});
